export default class ColorHelper {
	hexToRgb(hex) {
		// Remove the hash if it's there
		hex = hex.replace(/^#/, '');

		// Expand 3-digit hex to 6-digit
		if (hex.length === 3) {
			hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
		}

		const r = parseInt(hex.slice(0, 2), 16);
		const g = parseInt(hex.slice(2, 4), 16);
		const b = parseInt(hex.slice(4, 6), 16);
		return [r, g, b];
	}

	getRelativeLuminance(r, g, b) {
		const rgb = [r, g, b].map(v => {
			v /= 255;
			return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
		});
		return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
	}

	isLightColor(hex) {
		const [r, g, b] = this.hexToRgb(hex);
		const luminance = this.getRelativeLuminance(r, g, b);
		return luminance > 0.5; // true for light colors, false for dark colors
	}
}